function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#fff"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 11a3 3 0 100-6 3 3 0 000 6zM9 20c-2.21 0-4.085-1.929-2.889-3.786A6.994 6.994 0 0112 13a6.994 6.994 0 015.889 3.214C19.085 18.07 17.209 20 15 20H9z",
  fill: "#0098FF"
});
function SvgPickerUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default __webpack_public_path__ + "/img/picker-user.svg";
export { SvgPickerUser as ReactComponent };